import { Component } from '@angular/core';

@Component({
  selector: 'app-score-registration-landing',
  templateUrl: './score-registration-landing.component.html',
  styleUrls: ['./score-registration-landing.component.scss']
})
export class ScoreRegistrationLandingComponent {

}
